<template lang="pug">
el-form(
  ref="refForm"
  :rules="rules"
  :model="item"
  status-icon
  label-position="top"
)
  app-main-content-layout(title='Organization Details' back-to='/manage/orgs')
    template(#actions)
      el-button(type="info").has-fai
        fai(type="fal" icon="envelope").size-18.me-2
        span.min-w-110.d-inline-block Send Message
      el-button(type="primary" @click="validateForm" v-loading="loading").has-fai
        fai(type="fal" icon="save").size-18.me-2
        span.min-w-110.d-inline-block Save

    template(#col-left)
      div
        .row
          .col-md-6
            el-form-item(label="Organization Name" prop="name")
              el-input(v-model="item.name")
          .col-md-6
            el-form-item
              template(#label)
                | Slug
                el-tooltip(
                  effect="customized"
                  :content="slugTip"
                  placement="top"
                  popper-class="max-w-350"
                )
                  fai(type="fal" icon="info-circle").size-18.ms-2
              el-input(v-model="item.slug" @input="sanitizeSlug")
          .col-md-6(v-if="item.stripe_onboarded")
            el-form-item(label="Payment Integration" prop="stripe_onboarded")
              el-input(v-model="item.isStripeOnboarded"
                prefix-icon="stripe-wordmark"
                suffix-icon="el-icon-circle-close" circle
                @click="removeStripeConnection"
                readonly)

        el-form-item
          template(#label)
            | About
            el-tooltip(
              v-if="item.organization_type !== 'NONPROFIT'"
              effect="customized"
              content="Introduce your brand and primary reason for existing. \
                Consider leaning into your brand voice to include the founding backstory,\
                your vision for tomorrow, and why your fruits of labor matter."
              placement="top"
              popper-class="max-w-350"
            )
              fai(type="fal" icon="info-circle").size-18.ms-2
          el-input(v-model="item.about" type="textarea" :rows="6")

        el-form-item
          template(#label)
            //- earlier the label was `Our Purpose`
            | Our Ethos
            el-tooltip(
              v-if="item.organization_type !== 'NONPROFIT'"
              effect="customized"
              :content='`Define your brand\'s "purpose statement" to capture your catalyst, \
                commitment, and responsibility. Consider including what you want to accomplish, \
                who that will be for, and how you plan to make stuff better.`'
              placement="top"
              popper-class="max-w-350"
            )
              fai(type="fal" icon="info-circle").size-18.ms-2
          el-input(v-model="item.purpose" type="textarea"  maxlength="125" show-word-limit :rows="4")

      div
        user-common-sections(:item="item")

      div
        el-form-item(label="In-App Organization Link")
          .link-input-group
            el-input(:value="orgDeepLink" readonly size="small")
            el-button(type="primary" size="small" @click="copyOrgDeepLink")
              span.ms-1 Copy

      div(v-if="item.is_creator")
        .row
          org-stickers(:stripe_onboarded="item.stripe_onboarded")

    template(#col-right)
      div
        .row
          .col-md-6
            h5 Avatar
            el-upload(
                :show-file-list="false"
                :on-success="handleSuccess"
                :on-error="handleError"
                :before-upload="beforeUpload"
                :http-request="handleAvatarUpload"
                v-loading="uploading.avatar"
                action=""
            ).img-uploader.pos-r.mb-4
                template(v-if="item.avatar")
                  img(:src="item.avatar").uploaded-image
                  .pin.pin-bx.d-flex.p-2
                    el-button(type="primary").ms-auto Change
                template(v-else)
                  .upload-empty-state
                    img(src="@/assets/icons/file-image-outline.svg").img-uploader-icon
                    p.upload-picture-text Drop image here or
                    el-button(type="primary" size="small").fake-upload-button Browse

          .col-md-6
            h5 Background
            el-upload(
                :show-file-list="false"
                :on-success="handleSuccess"
                :on-error="handleError"
                :before-upload="bUploads.beforeUpload"
                :http-request="handleBackgroundUpload"
                v-loading="uploading.background"
                action=""
            ).img-uploader.pos-r.mb-4
                template(v-if="item.background")
                  img(:src="item.background").uploaded-image
                  .pin.pin-bx.d-flex.p-2
                    el-button(type="primary").ms-auto Change
                template(v-else)
                  .upload-empty-state
                    img(src="@/assets/icons/file-image-outline.svg").img-uploader-icon
                    p.upload-picture-text Drop image here or
                    el-button(type="primary" size="small").fake-upload-button Browse

      div
        el-form-item(label="Share Organization Profile")
          .qr-code-section
            qrcode-vue(:value="orgUrl" :size="220")
            .link-with-copy.mt-2
              a.primary-color-text(
                :href="orgUrl"
                target="_blank"
                rel="noopener noreferrer"
              ) {{ orgUrl }}
              el-button(type="primary" size="small" @click.stop="copyOrgUrl").ms-2
                span Copy

      div
        el-form-item(label="Category")
          .p-1.bg-light.rounded
            .el-tag-wrapper
              el-tag(
                type="info" :key="index"
                v-for="(category, index) in item.categories"
              ) {{ category }}

        el-form-item(label="Organization Type")
          el-input(v-model="item.orgType" disabled)

        el-form-item(label="Email")
          el-input(v-model="item.email" type="email" disabled)

        el-form-item(label="Date Established")
          el-date-picker(
            v-model="item.estdDate"
            type="date"
            placeholder="MM / DD/ YYYY"
            format="MM/DD/YYYY"
            disabled
          ).w-100

        el-form-item(label="Referral Code Used")
          el-input(v-model="item.referralCodeUsed" disabled)

        el-form-item
          template(#label) Created
            span.text-muted.ms-2
          el-input(v-model="item.createdAt" disabled)

        el-form-item(v-if="item.admins.length")
          template(#label) Admins
            //- el-button(link @click="item.isAddAdmin = !item.isAddAdmin").ms-auto
            //-      | Add User
          .py-1.px-2.bg-light.rounded
            .row.row-xs.align-items-center(v-for="admin in item.admins" :key="admin.id")
              .col-auto
                img(:src="admin.avatar"
                  v-if="admin.avatar").d-block.size-32.obj-f-c.rounded-circle
                img(src="@/assets/images/default-profile.jpeg"
                  v-if="!admin.avatar").d-block.size-32.obj-f-c.rounded-circle
              .col.lh-1 {{ admin.firstname }} {{ admin.lastname }}
              .col-auto
                el-button(
                  link
                  :disabled="item.admins.length == 1"
                  @click="removeAdminUserFromOrg(admin.id, $event)").ms-auto
                  | Remove
              .col-auto
                el-button(link @click="viewUser(admin.id, $event)").ms-auto
                  | View Details

            el-button(link @click="item.isAddAdmin = !item.isAddAdmin").ms-auto
                  | Add User

            el-form-item(v-if="item.isAddAdmin").margin-bottom-10
              template(#label)
                .col-md-9
                  el-input(v-model="item.adminEmail" placeholder="ex: abcd@spotlight.com" v-lowercase-email)
                .col-md-3
                  el-button(type="primary" @click="addAdminUserToOrg").margin-left-10
                    span.d-inline-block Add
</template>

<script>
import {
  defineComponent,
  reactive,
  ref,
  onMounted,
  watch,
  computed
} from 'vue';
import { mask } from 'vue-the-mask';
import { requiredRule } from '@/data/rules';
import { bullhorns, orgValues, channels } from '@/data/onboarding-static';
import fileUpload from '@/shared/upload';
import UserCommonSections from '../UserCommonSections.vue';
import OrgStickers from './OrgStickers.vue';
import shared from '../shared';
import lowercaseEmail from '@/directives/lowercase-email.js';
import { useStore } from 'vuex';
import { ElMessage } from 'element-plus';
import QrcodeVue from 'qrcode.vue';

const itemData = {
  name: '',
  slug: '',
  bullhorns,
  about: '',
  purpose: '',
  allies: bullhorns,
  values: orgValues,
  channels,
  interests: [],
  accountStatus: '1',
  categories: [],
  orgType: '501(c)',
  location: '90068  Los Angeles, CA',
  email: 'emailname@provider.com',
  phone: '(123) 456-789',
  estdDate: new Date(),
  twoFactorAuthentication: 'Phone',
  personalReferralCode: '94le384ngle',
  betaTester: 'Yes',
  referralCodeUsed: '234uf22iMX3',
  avatar: '',
  background: '',
  createdAt: '',
  primaryAdmin: {
    name: 'FirstName LastName',
    imgUrl: '//picsum.photos/200/300?random=2',
  },
  adminEmail: '',
  isAddAdmin: false,
  admins: [],
  isStripeOnboarded: '',
};

export default defineComponent({
  name: 'ManageContentOrgEdit',
  components: { UserCommonSections, OrgStickers, QrcodeVue },
  directives: { mask, lowercaseEmail },

  setup() {
    const store = useStore();
    const {
      route,
      router,
      loading,
      getOrganization,
      dateAndTime,
      dobDate,
      doUpdateOrgProfile,
      addAdminUserToOrgRequest,
      removeAdminUserFromOrgRequest,
      reqRemoveStripeAccount,
      getConfirm,
    } = shared();
    const bUploads = fileUpload('backgrounds', 'Background');
    const { uploadStatus, beforeUpload, handleUploadRequest } = fileUpload('avatars', 'Avatar');

    const { orgId } = route.params;
    const item = reactive(itemData);
    const refForm = ref(null);
    const uploading = reactive({
      avatar: false,
      background: false,
    });

    const selectedOrganization = computed(() => store.getters['organizations/GET_SELECTED_ORGANIZATION']);

    async function getOrganizationDetails(id) {
      loading.value = true;
      const organization = await getOrganization(id);
      item.name = organization.name;
      item.slug = organization.slug;
      item.about = organization.about;
      item.purpose = organization.purpose;
      item.bullhorns = organization.bullhorns;
      item.values = organization.values;
      item.channels = organization.channels;
      item.email = organization.email;
      item.background = organization.background;
      item.avatar = organization.avatar;
      item.categories = organization.organizationTypes;
      item.estdDate = dobDate(organization.dob);
      item.active = organization.active;
      item.is_creator = organization.is_creator;
      item.stripeAccountid = organization.stripeAccountid;
      item.stripe_onboarded = organization.stripe_onboarded;
      [item.createdAt] = dateAndTime(organization.createdAt);
      if (item.categories.length > 0) {
        item.orgType = organization.organizationTypes.join(',');
      }
      item.referralCodeUsed = organization.inviteCode;
      item.primaryAdmin = organization.primaryAdmin;
      item.admins = organization.admins;
      item.isStripeOnboarded = item.stripe_onboarded ? 'Connected' : 'Not Connected';
      item.interests = organization.interests;
      loading.value = false;
    }

    onMounted(async () => {
      if (orgId) {
        await getOrganizationDetails(orgId);
      } 
      else if (selectedOrganization.value && selectedOrganization.value.id) {
        await getOrganizationDetails(selectedOrganization.value.id);
      }
    });

    watch(selectedOrganization, async (newOrg) => {
      if (newOrg && newOrg.id) {
        await getOrganizationDetails(newOrg.id);

        if (route.path !== `/manage/orgs/${newOrg.id}/edit`) {
          router.push(`/manage/orgs/${newOrg.id}/edit`);
        }
      }
    });

    async function removeStripeConnection() {
      const msg = 'Do you wish to remove your stripe account connection. Are you Sure?';
      getConfirm(msg, async () => {
        loading.value = true;
        const organizationId = orgId;
        await reqRemoveStripeAccount({
          orgId: organizationId,
        });
        await getOrganizationDetails();
        loading.value = false;
      });
    }

    const slugTip = computed(() => {
      return 'A slug is a URL-friendly version of your organization name. It creates clean, memorable URLs like "spotlight.xyz/web/org/your-org-name" instead of "spotlight.xyz/web/org/123". '
        + 'Slugs improve SEO, make sharing easier, and provide a professional appearance. Use lowercase letters, numbers, and hyphens only.';
    });

    function sanitizeSlug() {
      item.slug = item.slug.replace(/[^a-z0-9-]/g, '').toLowerCase();
    }

    async function updateProfileForOrg() {
      loading.value = true;
      try {
        await doUpdateOrgProfile(orgId, {
          name: item.name,
          slug: item.slug,
          about: item.about,
          purpose: item.purpose,
          avatar: item.avatar,
          background: item.background,
        });
        await getOrganizationDetails(orgId);
        ElMessage({
          message: 'Organization profile updated successfully',
          type: 'success',
        });
      } catch (error) {
        console.error('Error updating organization profile:', error);
        
        // Extract error message from GraphQL response
        let errorMessage = 'Failed to update organization profile';
        if (error.graphQLErrors && error.graphQLErrors.length > 0) {
          errorMessage = error.graphQLErrors[0].message;
        } else if (error.message) {
          errorMessage = error.message;
        }
        
        ElMessage({
          message: errorMessage,
          type: 'error',
        });
      } finally {
        loading.value = false;
      }
    }

    function validateForm() {
      refForm.value.validate(async (valid) => {
        if (valid) {
          try {
            await updateProfileForOrg();
          } catch (error) {
            // Error is already handled in updateProfileForOrg
            console.error('Error in validateForm:', error);
          }
        }
        return false;
      });
    }

    function viewUser(id, event) {
      event.preventDefault();
      router.push(`/manage/users/${id}/edit`);
    }

    async function handleAvatarUpload(payload) {
      uploading.avatar = true;
      await handleUploadRequest(payload);
      uploading.avatar = false;
      if (uploadStatus.status === 'ok') {
        item.avatar = uploadStatus.resourceUrl;
      }
    }

    async function handleBackgroundUpload(payload) {
      uploading.background = true;
      await bUploads.handleUploadRequest(payload);
      uploading.background = false;
      if (bUploads.uploadStatus.status === 'ok') {
        item.background = bUploads.uploadStatus.resourceUrl;
      }
    }

    async function addAdminUserToOrg() {
      loading.value = true;
      const organizationId = orgId;
      const result = await addAdminUserToOrgRequest({
        orgId: organizationId,
        userEmail: item.adminEmail,
      });
      if (result.addAdminUserToOrg === true) {
        item.isAddAdmin = false;
        item.adminEmail = '';
      }
      await getOrganizationDetails();
      loading.value = false;
    }

    async function removeAdminUserFromOrg(id, event) {
      event.preventDefault();
      loading.value = true;
      const organizationId = orgId;
      await removeAdminUserFromOrgRequest({
        orgId: organizationId,
        userId: id,
      });
      await getOrganizationDetails();
      loading.value = false;
    }

    function handleSuccess() {
      console.log('success');
    }

    function handleError() {
      console.log('error');
    }

    // Computed property for organization profile URL
    const orgUrl = computed(() => {
      if (item.slug) {
        return `${import.meta.env.VITE_WEB_BASE_URL}/web/org/${item.slug}?tab=shop`;
      }
      // Fallback to ID-based URL when no slug is available
      const currentOrgId = item.id || orgId || (selectedOrganization.value && selectedOrganization.value.id);
      return `${import.meta.env.VITE_WEB_BASE_URL}/web/profile/organization/${currentOrgId}?tab=shop`;
    });

    // Computed property for organization deep link (ID-based for CMS)
    const orgDeepLink = computed(() => {
      const currentOrgId = item.id || orgId || (selectedOrganization.value && selectedOrganization.value.id);
      return `/profile/organization/${currentOrgId}`;
    });

    async function copyOrgDeepLink() {
      try {
        await navigator.clipboard.writeText(orgDeepLink.value);
        ElMessage({
          message: 'Organization deep link copied to clipboard!',
          type: 'success',
        });
      } catch (error) {
        console.error('Failed to copy organization deep link:', error);
        ElMessage({
          message: 'Failed to copy deep link',
          type: 'error',
        });
      }
    }

    async function copyOrgUrl() {
      try {
        const urlToCopy = orgUrl.value;
        
        if (!urlToCopy) {
          throw new Error('URL is empty');
        }
        
        await navigator.clipboard.writeText(urlToCopy);
        ElMessage({
          message: 'Organization profile URL copied to clipboard!',
          type: 'success',
        });
      } catch (error) {
        console.error('Failed to copy organization URL:', error);
        
        // Fallback method for older browsers
        try {
          const textArea = document.createElement('textarea');
          textArea.value = orgUrl.value;
          textArea.style.position = 'fixed';
          textArea.style.left = '-999999px';
          document.body.appendChild(textArea);
          textArea.select();
          document.execCommand('copy');
          document.body.removeChild(textArea);
          
          ElMessage({
            message: 'Organization profile URL copied to clipboard!',
            type: 'success',
          });
        } catch (fallbackError) {
          console.error('Fallback copy also failed:', fallbackError);
          ElMessage({
            message: 'Failed to copy URL. Please copy manually.',
            type: 'error',
          });
        }
      }
    }

    return {
      // data
      loading,
      rules: {
        name: requiredRule('Name'),
      },
      item,
      refForm,
      // methods
      validateForm,
      viewUser,
      beforeUpload,
      handleSuccess,
      handleError,
      handleAvatarUpload,
      handleBackgroundUpload,
      bUploads,
      uploading,
      addAdminUserToOrg,
      removeAdminUserFromOrg,
      removeStripeConnection,
      selectedOrganization,
      slugTip,
      sanitizeSlug,
      orgUrl,
      orgDeepLink,
      copyOrgDeepLink,
      copyOrgUrl,
    };
  },
});
</script>

<style lang="scss" scoped>
// Color Variables - Match ManageUsers.vue
$color-teal-accent: #01beb0;
$gray-50: #f9fafb;
$gray-100: #f3f4f6;
$gray-200: #e5e7eb;
$gray-300: #d1d5db;
$gray-400: #9ca3af;
$gray-500: #6b7280;
$gray-600: #4b5563;
$gray-700: #374151;
$gray-900: #111827;
$color-purple-text: #4349dd;

// Main Form Container
:deep(.app-main-content-layout) {
  background-color: $gray-50;
  padding: 2rem;
}

// Form Styling
:deep(.el-form-item) {
  margin-bottom: 1.5rem;

  .el-form-item__label {
    color: $gray-700;
    font-weight: 600;
    font-size: 0.875rem;
    line-height: 1.5;
    margin-bottom: 0.5rem;
    display: flex;
    align-items: center;
    gap: 0.25rem;
  }

  .el-input__wrapper {
    border-radius: 10px;
    border: 1.5px solid $gray-200;
    background: #F0F0F3;
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.03);
    padding: 0 12px;
    height: 40px;
    transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);

    &:hover:not(.is-disabled) {
      border-color: $color-purple-text;
      box-shadow: 0 2px 4px 0 rgba(67, 73, 221, 0.08);
    }

    &.is-focus {
      border-color: $color-purple-text;
      box-shadow: 0 0 0 3px rgba(67, 73, 221, 0.12), 0 2px 4px 0 rgba(67, 73, 221, 0.08);
    }

    &.is-disabled {
      border: 1.5px solid $gray-200;
      background: #F0F0F3;
    }
  }

  .el-input__inner {
    height: 100%;
    font-size: 0.875rem;
    color: $gray-700;
    background: transparent;
    font-weight: 500;

    &::placeholder {
      color: $gray-400;
      font-weight: 400;
    }
  }

  .el-textarea__inner {
    border-radius: 10px;
    border: 1.5px solid $gray-200;
    background: #F0F0F3;
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.03);
    padding: 12px;
    color: $gray-700;
    font-weight: 500;
    font-size: 0.875rem;
    line-height: 1.5;
    transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
    min-height: 100px;

    &:hover {
      border-color: $color-purple-text;
      box-shadow: 0 2px 4px 0 rgba(67, 73, 221, 0.08);
    }

    &:focus {
      border-color: $color-purple-text;
      box-shadow: 0 0 0 3px rgba(67, 73, 221, 0.12), 0 2px 4px 0 rgba(67, 73, 221, 0.08);
    }

    &::placeholder {
      color: $gray-400;
      font-weight: 400;
    }
  }
}

// Button Styling
:deep(.el-button) {
  border-radius: 8px;
  font-weight: 600;
  font-size: 0.875rem;
  height: 36px;
  padding: 0 20px;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  border-width: 1px;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.03);
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  gap: 0.5rem;

  > span {
    display: inline-flex;
    align-items: center;
    line-height: 1;
  }

  .fai,
  svg {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    line-height: 1;
    margin-right: 0.5rem;
  }

  &.min-w-110 {
    min-width: 110px;
  }

  &.el-button--primary {
    background-color: $color-purple-text;
    border-color: $color-purple-text;
    color: white;

    &:hover,
    &:focus {
      background-color: color.adjust($color-purple-text, $lightness: -8%);
      border-color: color.adjust($color-purple-text, $lightness: -8%);
      box-shadow: 0 2px 4px 0 rgba(67, 73, 221, 0.2);
      transform: translateY(-1px);
    }

    &:active {
      background-color: color.adjust($color-purple-text, $lightness: -10%);
      border-color: color.adjust($color-purple-text, $lightness: -10%);
      transform: translateY(0);
      box-shadow: 0 1px 2px 0 rgba(67, 73, 221, 0.2);
    }
  }

  &.el-button--small {
    padding: 0 12px;
    font-size: 0.8125rem;
    height: 32px;
  }
}

// Image Upload Styling
.img-uploader {
  border: 2px dashed $gray-300;
  border-radius: 10px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  transition: all 0.3s;
  background-color: $gray-50;
  min-height: 200px;
  height: 200px;

  &:hover {
    border-color: $color-purple-text;
    background-color: color.adjust($color-purple-text, $lightness: 45%);
  }

  .uploaded-image {
    width: 100%;
    height: 200px;
    object-fit: cover;
    display: block;
  }

  .upload-empty-state {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 1.5rem 1rem;
    height: 100%;
  }

  .img-uploader-icon {
    width: 48px;
    height: 48px;
    margin-bottom: 0.75rem;
    display: block;
    opacity: 0.5;
  }

  .upload-picture-text {
    text-align: center;
    color: $gray-600;
    font-size: 0.625rem !important;
    margin-bottom: 0.5rem;
    font-weight: 400;
    line-height: 1.2;
  }

  .fake-upload-button {
    // Styled as a button, not just text
    pointer-events: none; // Let the parent el-upload handle the click
    // Match the size of the "Change" button exactly
    height: 36px !important;
    padding: 0 20px !important;
    font-size: 0.875rem !important;
    font-weight: 600 !important;
    border-radius: 8px !important;
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.03) !important;
    border-width: 1px !important;
  }

  .pin-bx {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    background: linear-gradient(to top, rgba(0,0,0,0.7), transparent);
    
    .el-button {
      // Ensure Change button matches Browse button
      height: 36px;
      padding: 0 20px;
      font-size: 0.875rem;
      font-weight: 600;
      border-radius: 8px;
    }
  }
}

// Additional specificity for upload text
:deep(.img-uploader) {
  .upload-picture-text {
    font-size: 0.625rem !important;
  }
}

// Admins List Styling
.py-1 {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}

.px-2 {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}

.bg-light {
  background-color: $gray-100;
}

.rounded {
  border-radius: 8px;
}

.row-xs {
  margin-left: -0.25rem;
  margin-right: -0.25rem;

  > [class*="col"] {
    padding-left: 0.25rem;
    padding-right: 0.25rem;
  }
}

.size-32 {
  width: 32px;
  height: 32px;
}

.obj-f-c {
  object-fit: cover;
}

.rounded-circle {
  border-radius: 50%;
}

.lh-1 {
  line-height: 1;
  font-weight: 500;
  color: $gray-900;
  font-size: 0.875rem;
}

.margin-bottom-10 {
  margin-bottom: 10px;
}

.margin-left-10 {
  margin-left: 10px;
}

// QR Code Section Styling
.qr-code-section {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.link-with-copy {
  display: flex;
  align-items: center;
  width: 100%;
  flex-wrap: wrap;
  gap: 0.5rem;
}

.primary-color-text {
  color: $color-purple-text;
  font-size: 0.875rem;
  font-weight: 500;
  text-decoration: none;
  word-break: break-all;
  transition: color 0.2s ease;
  flex: 1;
  min-width: 0;

  &:hover {
    color: color.adjust($color-purple-text, $lightness: -10%);
    text-decoration: underline;
  }
}

// Link Input Group Styling
.link-input-group {
  display: flex;
  gap: 8px;
  align-items: center;
}

.link-input-group .el-input {
  flex: 1;
}

// Tooltip Styling
:deep(.el-tooltip__trigger) {
  .size-18 {
    color: $gray-400;
    transition: color 0.2s ease;

    &:hover {
      color: $gray-600;
    }
  }
}

// Title Styling
:deep(h1) {
  font-size: 1.875rem;
  font-weight: 600;
  color: $gray-900;
  line-height: 1.2;
}

h5 {
  font-size: 1rem;
  font-weight: 600;
  color: $gray-900;
  margin-bottom: 1rem;
}

// Responsive Design
@media (max-width: 768px) {
  :deep(.app-main-content-layout) {
    padding: 1.5rem;
  }

  :deep(.el-form-item) {
    margin-bottom: 1.25rem;

    .el-form-item__label {
      font-size: 0.8125rem;
    }

    .el-input__inner,
    .el-textarea__inner {
      font-size: 0.8125rem;
    }
  }

  :deep(.el-button) {
    padding: 8px 16px;
    font-size: 0.8125rem;
  }
}

@media (max-width: 576px) {
  :deep(.app-main-content-layout) {
    padding: 1rem;
  }
}
</style>
